import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiLogin, apiRegister, apiMe, toggleFavoriteApi } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = useCallback(async () => {
    const token = localStorage.getItem("mlv_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const u = await apiMe();
      setUser(u);
    } catch (e) {
      localStorage.removeItem("mlv_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  const login = async (email, password) => {
    const data = await apiLogin({ email, password });
    localStorage.setItem("mlv_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (body) => {
    const data = await apiRegister(body);
    localStorage.setItem("mlv_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("mlv_token");
    setUser(null);
  };

  const toggleFavorite = async (villaId) => {
    if (!user) return { needLogin: true };
    const res = await toggleFavoriteApi(villaId);
    setUser((u) => ({ ...u, favorites: res.favorites }));
    return res;
  };

  const isFavorite = (villaId) => !!user?.favorites?.includes(villaId);

  return (
    <AuthContext.Provider
      value={{ user, loading, login, register, logout, refreshUser, toggleFavorite, isFavorite }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
